(function(){
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function toast(msg){
    var t = document.querySelector('.pp-toast');
    if(!t){ t = document.createElement('div'); t.className = 'pp-toast'; t.setAttribute('role','status'); t.setAttribute('aria-live','polite'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('show'); }, 2200);
  }
  function setCount(n){
    document.querySelectorAll('.pp-bag-count').forEach(function(el){ el.textContent = n; });
  }
  function refreshCount(){
    fetch(root + 'cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(c){ setCount(c.item_count); }).catch(function(){});
  }
  function addToCart(id, btn){
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function(s){ return s.id; });
      body.sections_url = window.location.pathname;
    }
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'ADDING…';
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ if(!r.ok){ throw new Error(j.description || j.message || 'Could not add to bag'); } return j; }); })
      .then(function(j){
        btn.textContent = 'ADDED';
        if (drawer && j.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          var item = (j.items && j.items[0]) || {};
          drawer.renderContents({ id: item.id, sections: j.sections });
        } else {
          toast('Added to your bag');
        }
        if (window.publish && window.PUB_SUB_EVENTS) { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pp-quick-add', productVariantId: id }); } catch(e){} }
        refreshCount();
        setTimeout(function(){ btn.disabled = false; btn.textContent = btn.dataset.label || label; }, 1600);
      })
      .catch(function(err){
        toast(err.message);
        btn.disabled = false; btn.textContent = btn.dataset.label || label;
      });
  }
  document.addEventListener('click', function(e){
    var q = e.target.closest('.pp-quick');
    if (q) {
      e.preventDefault();
      var card = q.closest('[data-pp-card]');
      if (q.dataset.variant) { addToCart(q.dataset.variant, q); return; }
      var sizes = card && card.querySelector('.pp-sizes');
      if (sizes) {
        var open = sizes.hasAttribute('hidden');
        document.querySelectorAll('.pp-sizes').forEach(function(s){ s.setAttribute('hidden',''); });
        document.querySelectorAll('.pp-quick[data-sizes]').forEach(function(b){ b.textContent = 'QUICK ADD'; });
        if (open) { sizes.removeAttribute('hidden'); q.textContent = 'SELECT A SIZE'; var f = sizes.querySelector('.pp-size:not(:disabled)'); if (f) f.focus(); }
      }
      return;
    }
    var s = e.target.closest('.pp-size');
    if (s) {
      e.preventDefault();
      var c = s.closest('[data-pp-card]');
      var qb = c.querySelector('.pp-quick');
      c.querySelector('.pp-sizes').setAttribute('hidden','');
      addToCart(s.dataset.id, qb).then(function(){ setTimeout(function(){ qb.textContent = 'QUICK ADD'; }, 1700); });
      return;
    }
    var t = e.target.closest('[data-pp-toggle]');
    if (t) {
      e.preventDefault();
      var id = t.getAttribute('data-pp-toggle');
      var panel = document.getElementById(id);
      var willOpen = !panel.classList.contains('is-open');
      document.querySelectorAll('.pp-panel').forEach(function(p){ p.classList.remove('is-open'); });
      document.querySelectorAll('[data-pp-toggle]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
      if (willOpen) { panel.classList.add('is-open'); t.setAttribute('aria-expanded','true'); var inp = panel.querySelector('input'); if (inp) inp.focus(); }
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { document.querySelectorAll('.pp-panel').forEach(function(p){ p.classList.remove('is-open'); }); }
  });
  if (window.subscribe && window.PUB_SUB_EVENTS) { try { subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount); } catch(e){} }
  window.addEventListener('pageshow', refreshCount);
})();
